// extracted by mini-css-extract-plugin
export var actionRow = "_nx-6";
export var card = "_nx-0";
export var chevron = "_nx-5";
export var content = "_nx-2";
export var details = "_nx-3";
export var eventActionToggle = "_nx-4";
export var icon = "_nx-1";
export var iconBlue = "_nx-8";
export var iconBrand = "_nx-7";
export var iconGrayBlue = "_nx-9";
export var iconGreen = "_nx-a";
export var iconIndigo = "_nx-b";
export var iconOrange = "_nx-c";
export var iconPurple = "_nx-d";
export var iconRed = "_nx-e";
export var iconWarning = "_nx-f";